module.exports = __webpack_public_path__ + "assets/img/zombie-hand.bbd6ab30.png";